<template>
	<div>
		<!--<p class="mb-4">
			<router-link tag="a" :to="{ name : 'organization.dashboard'}" class="button icon-button">
				<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
				<span>Back</span>
			</router-link>
		</p>-->
		
		 <p class="border-bottom mb-2 text-uppercase pb-2 d-flex align-items-center" v-if="course_data">
			 <span class="h2 m-0">{{ course_data.name }}</span>
			 <button v-b-toggle.collapse1 class="button ml-3" variant="primary">
			 	<small class="">Show details</small> <img width="4" class="ml-1" src="../../../assets/images/icons/solid/info_white.svg">
			 </button>
		  </p>
		  <b-collapse id="collapse1" class="mt-2">
		    <b-card>
		      <div class="row" v-if="course_data">
				<div class="col-12 col-lg-8 d-flex">
					<div class="lightgray-content rounded p-3 pt-4 pb-4  w-100">
						<div class="row">
							<div class="col-12 col-lg-6" >
								<p><strong class="mr-3 mb-1">Program: </strong></p>
								<p><span class="green h2">"{{ course_data.name }}"</span></p>
							</div>
							<div class="col-12 col-lg-6">
								<p><strong class="mr-3  mt-2 mb-1">Description:</strong></p>
								<p><span class="regular italic  mt-2 mb-1">{{ course_data.description }}</span></p>
							</div>
						</div><!--row-->
					</div><!--lightgray_content-->
						
				</div><!--col-->
				<div class="col-12 col-lg-4 d-flex">
					<div class="thumb-container w-100 rounded green-effect"  v-bind:style="{ backgroundImage: 'url(' + course_data.image + ')' }">
					</div>
				</div><!--col-->
			</div><!--row-->
		    </b-card>
		  </b-collapse>
		
		
		<div class="row mt-4">			
		
    		<div class="col-12 col-lg-6 col-xl-4" v-if="providers_status_loaded">
    			<program-schedule-chart class="w-100" :course="id" v-on:filter="setFilterGraphics"/>
    		</div>
    		<div class="col-12 col-lg-6 col-xl-4" v-if="providers_status_loaded">
    			<hours-learned  :course="id" class="w-100" v-on:filter="setFilterGraphics"/>
				<program-progress-completion  :course="id" class="w-100" v-on:filter="setFilterGraphics" v-if="false"/>
    		</div>
    		<div class="col-12 col-lg-6 col-xl-4" v-if="providers_status_loaded">
    			<sign-ups-pie-chart class="w-100" :course="id" v-on:filter="setFilterGraphics"/>
    		</div>
		
			
			<!--
			<div class="col-12 col-lg-4 d-flex" v-if="providers_status_loaded">
				<completion-pie-chart :height="250" @filterApplied="applyFilter" :providers_status="providers_status"/>
			</div>
			<div class="col-12 col-lg-4 d-flex">
				<test-chart :height="250" />
			</div>-->
		</div><!--row-->
		<hr class="mt-4 mb-4" />
		<div class="row justify-content-between align-items-center">
			<div class="col-6">
				<div class=" d-flex align-items-center mt-2 mb-4">
					<span class="h5">Employees registered to this program</span>

					<new-provider class="ml-2" v-if="permissions.indexOf('manage_provider_in_course') > -1" 
									:course="course_data" @addToCourseNew="newProviderAddToCourse" @addedToCourse="addedToCourse">
						<template slot="text-button"  class="m-0">
						New employee
						<img class="mr-1" src="../../../assets/images/icons/solid/plus_white.svg" width="11"/>
					</template>
					</new-provider>
					<!--
					<button type="button" class="button ml-2" @click="show_add_hha = true" v-if="permissions.indexOf('manage_provider_in_course') > -1">
						<img width="12" src="../../../assets/images/icons/solid/plus_white.svg">
						<span class="ml-1">Add new</span>
					</button>-->
				</div>

			</div><!--col-->

			<div class="col-6 text-right">


				<div class="trigger-hidden-content ml-1 d-inline-block">
					<span class=" button">
						Bulk actions <i class="fa fa-caret-down" aria-hidden="true"></i>
					</span>
					<div class="hidden-content hc-right-bottom"> 
						<div>
							<ul class="list-unstyled text-left">								
								<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="downloadAllkCerts()">									
									<img width="18" src="../../../assets/images/icons/solid/cert_2_black.svg" >
									<small class="ml-1">Download all certificates</small>
								</li>
								<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="messageToAll" v-if="permissions.indexOf('reply_messages') > -1">	
									<img width="18" src="../../../assets/images/icons/solid/envelope.svg">
									<small class="ml-1">Send message to all</small>
								</li>
								<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="approveAll" v-if="permissions.indexOf('approve_provider') > -1">
									<img width="18" src="../../../assets/images/icons/solid/check.svg">
									<small class="ml-1">Approve all employees</small>
								</li>
								<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="show_edit_due_date = true;edit_due_date_all=true">
									<img width="18" src="../../../assets/images/icons/solid/calendar.svg">
									<small class="ml-1">Edit due date</small>
								</li>
								<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer">
										<a :href="url_export | format_url(
											{
												show_course_progress : true,
												course_id : id,
												filter_graphic : filter_graphics.type,
												row : filter_graphics.row,
												column : filter_graphics.column,
												name : filters.names,
												order_by : filters.order_by,
												order_type : filters.order_type,
												search : search,
												image : false,
												download_token : download_token
											}
											)" target="_blank">

										<img width="18" class="mr-1" src="../../../assets/images/icons/solid/file-excel.svg">
										<small>Export</small>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div><!--row-->
		
		<!--
		<div class="row">
			<div class="d-flex justify-content-end align-items-center mt-2 mb-2">
				<button type="button" class="button test-content text-uppercase d-flex align-items-center m-0 ml-2" 
							@click="resetLessonProgress" title="Set the status to awaiting or in-progress">
						
					<span class="ml-2">RESET LESSON PROGRESS</span>
				</button>
				<button type="button" class="button test-content text-uppercase d-flex align-items-center m-0 ml-2" 
							@click="resetStatus" title="Set the status to awaiting or in-progress">
						
					<span class="ml-2">RESET STATUS</span>
				</button>
			</div>
		</div>
		-->
		

		<!-- modal add HHA -->

		<b-modal v-model="show_add_hha" title="Add employee" 
		 :ok-disabled="new_provider" @cancel="resetModal"
		size="lg">

			<p class="mb-2">
				<button  class="bold button green-content large-button text-uppercase" @click="new_provider = !new_provider">
					<span v-if="!new_provider">Create a new employee</span>
					<span v-else>Select from list</span>
				</button>
			</p>
			<p class="mt-4">
				<span v-if="!new_provider">...Or select from list:</span>
				<!-- <span v-else>Create employee</span> -->
			</p>
			
			<div  v-if="!new_provider">
				<div class="row justify-content-between align-items-end mb-2">
					<div class="col-12 col-md-4">
						<div class="input-content no-border m-0 ml-2">
							<input  class="m-0" type="text" placeholder="Search" v-model="search_all_providers_table" @keyup="keyUpSearchByNameAllProviders"/>
						</div>
					</div><!--col-->
					<div class="col-12 justify-content-end col-md-4 mb-1 col-lg-3 d-flex align-items-center">
						<small class="mr-2">Per page:</small>
						<multiselect v-model="all_providers_table.per_page" :options="[10, 25, 50, 100]" 
							:allow-empty="false" :show-labels="false" @select="changePerPageAllProviders"></multiselect>
					</div><!--col-->
				</div>
				<div class="table-responsive">
				<table class="table table-bordered">
					<tr class="align-midle">
						<!--<th></th>-->
						<th class="text">Mobile number</th>
						<th class="text">Name</th>
						<th class="text">Email</th>
						<th class="text">Actions</th>
					</tr>
					<tr v-for="item in all_providers" >
						<td>{{ item.country_code}}{{ item.phone }}</td>
						<td> {{ item.last_name }} {{ item.first_name }}</td>
						<td>{{ item.email }}</td>
						<td>

							<toggle-button v-model="item.in_course" 
										:labels="{ checked : 'Remove', unchecked : 'Add'}" :width="100"
										:switchColor="{ checked : red, unchecked : green }"
										:color="{ checked : red, unchecked : green, disabled : '#CCCCCC' }"
										@change="toggleProvider(item)" :sync="true"/>							
						</td>
					</tr>
				</table>

				<div class="col-6">
					Showing {{ all_providers_table.from }} to {{ all_providers_table.to }} of {{ all_providers_table.total }}
				</div><!--col-->

				<b-pagination align="right" :total-rows="all_providers_table.total" v-model="all_providers_table.current_page" :per-page="parseInt(all_providers_table.per_page)" @change="setPageAllProviders">
	    		</b-pagination>
			</div>
			</div>

			<organization-provider-create-component v-else @onSubmitNewProvider="onSubmitNewProvider" :share_view="true"
			:shared_phone="provider_data"
			:key="componentKey"
			></organization-provider-create-component>	


		</b-modal>
		
		<!-- modal edit due date -->
		<b-modal v-model="show_edit_due_date" title="Edit due date" size="md">
	   	
	   		<template v-if="!edit_due_date_all">
				<p class="text-center">You will edit the due date for the following employees:</p>

				<ul class="list-unstyled text-center" v-if="!edit_due_date_all">
					<li v-for="provider in providers" v-if="provider.checked">
						{{ provider.last_name }} {{ provider.first_name }}
					</li>
				</ul>
			</template>
			<template v-else>
				<p class="text-center">You will edit the due date for all employees</p>
			</template>
			<div class="form-group input-content">
				<label>Due date</label>

				<datetime v-model="edit_due_date" hidden-name="edit_due_date" name="edit-due-date" placeholder="New due date" ></datetime>

				<span class="input-error-msg" v-if="show_error_due_date">The due date is mandatory</span>
			</div>

			<div class="form-group">
				<div class="checkbox-container squared">
					<input id="checkbox-can-download-certificate" type="checkbox" v-model="notify_edit_due_date"/>
					<label for="checkbox-can-download-certificate" style="width:auto;">Notify employees</label>
				</div>
			</div>

			<div class="text-right">
				<small><i>The completed users will not be updated</i></small>
			</div>

			<div slot="modal-footer" class="w-100 row">
				<div class="col-6">
					<button class="button gray-content large-button w-100" @click="show_edit_due_date = false">Cancel</button>
				</div><!--col-->
				<div class="col-6">
					<button class="button large-button w-100" @click="bulkDueDate">Edit</button>
				</div><!--col-->
			</div>

		</b-modal>


		<b-modal v-model="send_group_message" title="Send group message" size="md">
			<p>Send message to :</p>

			<ul class="list-unstyled text-center">
				<li v-for="provider in providers" v-if="provider.checked">
					{{ provider.last_name }} {{ provider.first_name }} 
				</li>
			</ul>

			<div class="input-content mb-2">
				<textarea rows="13" v-model="bulk_message_text"></textarea>
			</div>

			<small>
				<p class="mt-2 mb-1">You can personalize the message with: </p>
				<ul>
					<li>%FIRST_NAME%: first name of the employee</li>
					<li>%LAST_NAME%: last name of the employee</li>
				</ul>
			</small>

			<div slot="modal-footer" class="w-100 row">
				<div class="col-6">
					<button class="button gray-content large-button w-100" @click="send_group_message = !send_group_message">Cancel</button>
				</div><!--col-->
				<div class="col-6">
					<button class="button large-button w-100" @click="bulkMessage">Send</button>
				</div><!--col-->
			</div>
		</b-modal>
		
		<b-modal v-model="approve_group" title="Approve group" size="md">
			<p class="text-center">You will approve the following employees:</p>

			<ul class="list-unstyled text-center">
				<li v-for="provider in providers" v-if="provider.checked && provider.completion == 100">
					{{ provider.last_name }} {{ provider.first_name }}
				</li>
			</ul>
			<p class="text-right">
				<small>You can only approve employees that completed the program</small>
			</p>
			<div slot="modal-footer" class="w-100 row">
				<div class="col-6">
					<button class="button gray-content large-button w-100" @click="approve_group = !approve_group">Cancel</button>
				</div><!--col-->
				<div class="col-6">
					<button class="button large-button w-100" @click="bulkApproval">Confirm</button>
				</div><!--col-->
			</div>
		</b-modal>
		

		<div class="pt-2 pb-2 table-filters mb-2">
			<div class="row justify-content-between align-items-end">
				<div class="col-12 col-md-3">
					<div class="input-content no-border m-0 ml-2">
						<input  type="text" placeholder="Search" v-model="search" @keyup="keyUpSearchByName"/>
					</div>
				</div><!--col-->
				<div class="col-12 col-md-5 col-lg-5 d-flex align-items-center">
					
					<!--
					<div class="d-flex justify-content-end align-items-center mt-2 mb-2" 
							v-if="bulk_actions && bulk_selection.length > 0">
					-->
					<div class="d-flex justify-content-end align-items-center mt-2">
					 	

					 	<div class="trigger-hidden-content ml-1 d-inline-block">
							<span class=" button">
								Actions <i class="fa fa-caret-down" aria-hidden="true"></i>
							</span>
							<div class="hidden-content hc-right-bottom"> 
								<div>
									<ul class="list-unstyled text-left">								
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="downloadBulkCerts()">		
											<img width="18" src="../../../assets/images/icons/solid/cert_2_black.svg">
											<small class="ml-1">Download certificates</small>
										</li>
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="send_group_message = true; send_message_to_all = false" v-if="permissions.indexOf('reply_messages') > -1">												
											<img width="18" src="../../../assets/images/icons/solid/envelope.svg">
											<small class="ml-1">Send message</small>											
										</li>
										<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="approve_group = true; approve_all = false" v-if="permissions.indexOf('approve_provider') > -1">
											<img width="18" src="../../../assets/images/icons/solid/check.svg">
											<small class="ml-1">Approve employees</small>
										</li>
										<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="show_edit_due_date = true; edit_due_date_all = false">
											<img width="18" src="../../../assets/images/icons/solid/calendar.svg">
											<small class="ml-1">Edit due date</small>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<button type="button" class="button gray-content d-flex align-items-center m-0 ml-2">
							<img width="18" height="18" src="../../../assets/images/icons/solid/times_white.svg">
							<small class="ml-1" @click="clearFilters">Clear filters</small>
						</button>
					</div>
				</div><!--col-->
				<div class="col-12 justify-content-end col-md-3 col-lg-3 d-flex align-items-center">
					<small class="mr-2">Per page:</small>
					<multiselect v-model="per_page" :options="[10, 25, 50, 100]" @select="changePerPage" :allow-empty="false" :show-labels="false"></multiselect>
				</div><!--col-->
			</div><!--row-->
		</div>	
		<!--
		<div class="row" v-if="course_data != null && false">
			<div class="col">
				<div class="text-right mb-2 mt-2">
					<div class="checkbox-container squared" @click="setCanDownloadCertificate()">
							<input id="checkbox-can-download-certificate" type="checkbox" v-model="course_data.can_download_certificate"/>
							<label for="checkbox-can-download-certificate" style="width:auto;">HHAs can download certificate from APP</label>
						</div>
					</td>
				</div>
			</div>
		</div>	
	-->

		<div class="table-responsive loadable" :class="{ 'loading' : !table_loaded }">
			<table class="table table-bordered progress-table">
				<thead>
					<tr class="green-content">
						<th class="text-center">
							<div class="checkbox-container squared">
								<input id="check-select-all" type="checkbox" />
								<label for="check-select-all" @click="selectAll"></label>
							</div>
						</th>
						<th></th>
						<th>Mobile number</th>
						<th>Name</th>
						<th class="text-center">Progress</th>
						<th>Hours left</th>
						<th>Due date</th>
						<th class="text-center">Months left</th>
						<th>Status </th>
						<th>Q. to RN</th>
						<th class="text-center min-width-100">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, i) in providers" 
							:class="{ 'disabled1 not-allowed1 not-active' : !item.active, 'checked' : item.checked, 'due-date-expired' : item.due_date_expired > 0 }">
						<td class="text-center">
							<div class="checkbox-container squared">
								<input :id="'checkbox-'+item.id" type="checkbox" v-model="item.checked"/>
								<label :for="'checkbox-'+item.id" @click="toggleBulkSelection(item.id)"></label>
							</div>
						</td>
						<td class="text-center">
							<router-link tag="a" :to="{ name : 'organization.courses.providers.detail', 
										params : { id: $route.params.id, provider_id : item.id } }" 
										:style="{ 'background-image' : 'url(data:image/jpeg;base64,'+item.image+')' }" 
							class="picture-container thumb-container" v-if="item.active"></router-link>

							<span v-else :style="{ 'background-image' : 'url(data:image/jpeg;base64,'+item.image+')' }" 
								class="picture-container thumb-container"></span>
						</td>
						<td>
							{{ item.country_code}}{{ item.phone }}
						</td>
						<td>
							<router-link tag="a" :to="{ name : 'organization.courses.providers.detail', 
												params : { id: $route.params.id, provider_id : item.id } }" class="bold" v-if="item.active">
											{{ item.last_name }}	{{ item.first_name }} 
							</router-link>
							<span class="bold" v-else>
								{{ item.last_name }} {{ item.first_name }} 
							</span>
						</td>
						<td>
                            <div class="completion-bar small-bar">
                                 <template v-if="(item.due_date_expired == 0)">
                                    <div v-bind:style="{ width: item.completion + '%' }"></div>
                                    <span v-if="item.sign_up == 0" class="not-active-text">USER HASN'T SIGNED UP</span>
                                    <span v-else>{{ item.completion }}%</span>

                                </template>
                                <template v-else>
                                    <div v-bind:style="{ width: item.completion + '%' }"></div>
                                    <span v-if="item.sign_up == 0" class="not-active-text">USER HASN'T SIGNED UP</span>
                                    <span v-else class="not-active-text">EXPIRED</span>
                                </template>
                            </div>
                        </td>
						<td>{{ item.hours_left_str }}</td>
						<td>
							<span :class=" {'due-date-expired' : item.due_date_expired > 0 }">
								{{ item.due_date }}
							</span>

							<template v-if="item.due_date_expired > 0">
								<div></div>
							</template>
						</td>
						<td v-if="item.months_left <= 0" class="text-center not-active-text">0</td>
						<td v-if="item.months_left > 0" class="text-center">{{ item.months_left }}</td>
						<td>

							<div class="d-flex">
								<div class="progress-icon"  :class="[item.status_str]"></div>

								<template v-if="item.status_str == 'approved'">
									<div class="progress-icon download" @click="downloadCert(item.certificate_url)">				            				
		            					
		            				</div>
								</template>
							</div>
							
								<!-- <div class="checkbox-container squared" v-if="item.status_str == 'awaiting'">
									<input :id="'checkbox-'+item.id" type="checkbox" v-model="bulk_approval[item.id]"/>
									<label :for="'checkbox-'+item.id" @click="singleApproval(item)"></label>
								</div> -->

						</td>
						<td class="text-center">
							<strong class="green">{{ item.questions_sent }}</strong>
						</td>
						<td class="text-center">
							<div class="d-flex justify-content-center">
							
								<!--<router-link tag="a" 
									:to="{ name : 'organization.courses.providers.detail', params : { id: $route.params.id, provider_id : item.id } }"
									 class="button">
									<img src="../../../assets/images/icons/solid/info_white.svg"  width="5" />
								</router-link>-->
								
								<div class="trigger-hidden-content ml-1 d-inline-block">
									<span class=" button">
										<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
									</span>
									<div class="hidden-content hc-right-bottom">
										<div>
											<ul class="list-unstyled text-left">
												<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" >
													<router-link tag="a" :to="{ name : 'organization.courses.providers.detail', params : { id: $route.params.id, provider_id : item.id } }">
														<img width="6" class="mr-2 ml-1" src="../../../assets/images/icons/solid/info.svg">
														<span>View details</span>
													</router-link>
												</li>
												<li  v-if="item.status == 'approved'" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="sendCertificate($route.params.id, item.id)">
													
													<img width="12" class="mr-2" src="../../../assets/images/icons/solid/cert_2_black.svg">
													<span>Send certificate</span>
												</li>
												<span style="display:none">
													<li class="pb-2 pt-2  align-items-center  cursor-pointer" @click="resetStatusProvider(item.id)">
														<img width="16" src="../../../assets/images/icons/solid/eraser.svg">
														<span>Reset status</span>
													</li>
													<li class="pb-2 pt-2  align-items-center  cursor-pointer" @click="resetLessons(item.id)">
														<img width="16" src="../../../assets/images/icons/solid/eraser.svg">
														<span>Reset lesson</span>
													</li>
													<li class="pb-2 pt-2  align-items-center  cursor-pointer" @click="completeLessons(item.id)">
														<img width="16" src="../../../assets/images/icons/solid/check.svg">
														<span>Complete lesson</span>
													</li>
												</span>
												<li class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" @click="showDeleteProvider(item)" v-if="permissions.indexOf('manage_provider_in_course') > -1">
													<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
													<span> Delete</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row justify-content-md-between align-items-center mt-4 mb-4">
			<div class="col-6">
				Showing {{ from }} to {{ to }} of {{ total_rows }}
			</div><!--col-->
			<div class="col-6">
				<b-pagination align="right" :total-rows="total_rows" v-model="current_page" :per-page="parseInt(per_page)" @change="setPage" class="m-0">
		    	</b-pagination>
			</div><!--col-->
		</div><!--row-->

		<!-- modal delete -->
		<b-modal v-model="show_delete_provider" title="Delete Employee" @ok="deleteProvider" cancel-title="No" ok-title="Yes">
	    	<div v-if="provider_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the EMPLOYEE {{ provider_to_delete.first_name }} 
					{{ provider_to_delete.last_name }}?
				</p>
			</div>
		</b-modal>
	</div>	
</template>

<script>
	import PhoneCountryCode from '../../shared/inputs/PhoneCountryCode';
	import OrganizationProviderCreateComponent from '../providers/OrganizationProviderCreateComponent';
	import { API_BASE } from '../../../config'	
	import TestChart from './../../charts/TestChart.js';
	import CompletionPieChart from './../../charts/CompletionPieChart.js';
	import PictureInput from 'vue-picture-input';
	export default {
		
	    components : {
	        TestChart, CompletionPieChart, PictureInput,
			OrganizationProviderCreateComponent,PhoneCountryCode
	    },
		data : function(){
			
			return {
				componentKey:0,
				id : this.$route.params.id,
				url_export : this.config.EXPORT_COURSE_PROGRESS,
				download_token : '',
				course_data : null,
				statuses : ['approved', 'pending', 'not-approved'],
				current_page : 1,
				total_rows : 15,
				preferred_languages : [],
				filters : {
					status : '',
					names : '',
					order_by : 'first_name',
					order_type : 'desc'
				},
				per_page  : 50,
				from : 0,
				to : 0,
				providers : [],
				search : '',
				search_all_providers_table : '',
				fields : [
					'id',
					'email',
					'name',
					// 'dob',
					'Actions'
				],
				selected_provider : null,
				show_add_hha : false,
				show_delete_provider : false,
				provider_to_delete : null,
				all_providers_table : {
					current_page : 0,
					total : 0,
					per_page : 50,
					from : 0,
					to : 0
				},
				table_loaded : false,
				all_providers : [],
				/* graphic pie */
				providers_status_loaded : false,
				providers_status : [],
				pie_filter : -1,
				show_edit_due_date : false,
				bulk_actions: false,
				send_group_message : false,
				approve_group : false,
				send_message_to_all : false,
				approve_all : false,
				bulk_selection : [],
				bulk_message_text : '',
				edit_due_date : null,
				edit_due_date_all : false,
				notify_edit_due_date : false,
				show_error_due_date : false,
				filter_graphics : {
					type : 'none',
					row : -1,
					column : -1
				},
				timeout_input_name : null,
				current_select_all : false,
				new_provider : false,
				provider_data : {
					ssn : '',
					first_name : '',
					last_name : '',
					// dob: '',
					email : '',
					// gender: '',
					preferred_language: '',
					phone: '',
					uid : null,
					onboard_date : null,
					timing_method_ : null,
					manager_approving_the_hha_score : '',
					coordinator : '',
					supporting_rn : '',
					lhcsa_manager : '',
					approving_completion : '',
					country_code : {
					},
					image:'',
					send_welcome_sms : true
				},
				red : this.config.COLORS.RED,
				green : this.config.COLORS.GREEN,
				country_codes : [],
				approving_completions : [],
				supporting_rn : [],
				coordinators : [],
				managers : [],
				disciplines : [],
				locations : [],
				location_mandatory : 0,
				discipline_mandatory : 0,
				dropzoneOptions: {
					url : API_BASE,
					thumbnailWidth: 50,
					maxFilesize: 50,
					maxFiles : 1,
					addRemoveLinks : true,
					headers : {
						'Autrollization' : localStorage.getItem('token')
					},
					autoProcessQueue : false
		   		 },
			}
		},
		watch:{
			edit_due_date: function(newVal, oldVal){

				if(newVal != '' || oldVal != ''){
					this.show_error_due_date = false
				}
			}
		},

		created : function(){
			this.getCountries();
			this.permissions = this.$store.getters.getPermissions;
			this.getProviders();
			this.getCourse();
			this.getAllProviders();

			this.getPreferredLanguages();
			this.getSubroles();
			this.providers_status_loaded = true;

			this.download_token = this.$store.getters.getDownloadToken;

			this.getLocations();
			this.getDisciplines();
			this.getMyOrganization();
		},

		methods : {
			getCountries : function(){
				this.$store.dispatch('getCountries', {}).then((res) => {
				
					this.country_codes = res.data.data;
				}).catch((error) =>{	
					console.log(error);
				});
			},
			countryInput: function(val){
				this.provider_data.country_code = val
			},
			getProviders : function() {

				this.table_loaded = false;
				var params = {
					filters : {
						page : this.current_page,
						show_course_progress : true,
						course_id : this.id,
						per_page : this.per_page,
						filter_graphic : this.filter_graphics.type,
						row : this.filter_graphics.row,
						column : this.filter_graphics.column,
						name : this.filters.names,
						order_by : this.filters.order_by,
						order_type : this.filters.order_type,
						search : this.search,
						image : true,
						page_loading : false
					}
				}
				this.$store.dispatch('getProvidersCountV2', params).then((res) => {
						this.total_rows = res.data
					}).catch((error) => {
						console.log(error)
					});

			    this.$store.dispatch('getProvidersV2', params).then((res) => {
						this.providers = res.data.data;
						this.current_page = res.data.meta.current_page;
						this.per_page = res.data.meta.per_page;
						this.from = res.data.meta.from;
						this.to = res.data.meta.to;
						this.checkProvidersStatus();
						this.table_loaded = true;

					}).catch((error) => {
						console.log(error);
					});
				
			},

			checkProvidersStatus : function(){
				var count = {
					'in-progress' : 0,
					approved : 0,
					awaiting : 0
				};
				for(var i in this.providers){
					count[this.providers[i].status]++;
				}

				this.providers_status = [count['in-progress'],count.awaiting,count.approved];
				
			},
			setPage : function(page){
				this.current_page = page;

				this.getProviders();

			},
			getCourse : function(){

				var params = {
					id : this.id,
					filters : {
						page_loading : true
					}
				}

				this.$store.dispatch('getCourse', params).then((res) => {
					this.course_data = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},
			selectProvider : function(provider){
				this.selected_provider = provider;
			},
			getAllProviders : function(page){
				if(this.permissions.indexOf('manage_provider_in_course') > -1){
					var params = {
						filters : {
							page : this.all_providers_table.current_page,
							in_course : this.id,
							per_page : this.all_providers_table.per_page,
							search : this.search_all_providers_table,
							page_loading: false
						},
						id : this.id
					}
					this.$store.dispatch('getProvidersCountV2', params).then((res) => {
						this.all_providers_table.total = res.data;
					}).catch((error) => {
						console.log(error)
					});

					this.$store.dispatch('getProvidersV2', params).then((res) => {
						this.all_providers = res.data.data;
						this.all_providers_table.current_page = res.data.meta.current_page;
						this.all_providers_table.per_page = res.data.meta.per_page;
						this.all_providers_table.from = res.data.meta.from;
						this.all_providers_table.to = res.data.meta.to;

					}).catch((error) => {
						console.log(error);
					});
				}
				
			},
			setPageAllProviders : function(page){
				this.all_providers_table.current_page = page;

				this.getAllProviders();
			},
			addProvider : function(provider_id){
				var params = {
					id : this.id,
					provider_id : provider_id
				}

				this.$store.dispatch('addProviderToCourse', params).then((res) => {
					this.getProviders();
					this.getAllProviders();
				}).catch((error) => {
					console.log(error);
				});
			},

			addedToCourse : function(){
				this.getProviders();
				this.getAllProviders();
			},
			showDeleteProvider : function(provider){
				this.provider_to_delete = provider;
				this.show_delete_provider = true;
			},
			deleteProvider : function(){
				var params = {
					id : this.id,
					provider_id : this.provider_to_delete.id
				}

				this.$store.dispatch('deleteProviderFromCourse', params).then((res) => {
					this.getProviders();
					this.getAllProviders();
				}).catch((error) => {
					console.log(error);
				});
			},
			applyFilter : function(filter_status){
				this.filters.status = filter_status;
			},
			toggleBulkSelection : function(provider_id){

				for(var i in this.providers){
					if(this.providers[i].id == provider_id ){
							this.$set(this.providers[i], 'checked', !this.providers[i].checked);
					}
						
				}

			},
			getProvidersForBulkMessage : function(){
				var provider_ids = [];
				for(var i in this.providers){
					if(this.providers[i].checked)
						provider_ids.push(this.providers[i].id);
				}

				return provider_ids;
			},
			getProvidersForBulkApproval : function(){
				var provider_ids = [];
				for(var i in this.providers){
					if(this.providers[i].checked && this.providers[i].completion == 100)
						provider_ids.push(this.providers[i].id);
				}

				return provider_ids;
			},
			getProvidersForBulkCert : function(){
				var provider_ids = [];
				for(var i in this.providers){
					if(this.providers[i].checked && this.providers[i].status == 'approved')
						provider_ids.push(this.providers[i].id);
				}

				return provider_ids;
			},
			bulkMessage : function(){
				var provider_ids = [];

				var params = {
					id : this.id,
					provider_ids : this.getProvidersForBulkMessage(),
					text : this.bulk_message_text,
					filters : {

					}
				}

				if(this.send_message_to_all)
					params.filters.all = true;

				this.send_message_to_all = false;
				this.current_select_all = !this.current_select_all;
				this.send_group_message = false;
				this.bulk_selection = [];
				this.bulk_message_text = '';

				this.$snotify.info('Sending message...');

				this.$store.dispatch('sendCourseBulkMessage', params).then((res) => {
					
					
					//this.getProviders();

					
				}).catch((error) => {
					console.log(error);
					this.send_message_to_all = false;
				});
			},

			bulkDueDate : function(){
				var provider_ids = [];
				if(this.edit_due_date === ''){
					this.show_error_due_date = true
					return
				}

				var params = {
					id : this.id,
					provider_ids : this.getProvidersForBulkMessage(),
					date : this.edit_due_date,
					all : this.edit_due_date_all,
					notify : this.notify_edit_due_date
				}

				this.current_select_all = !this.current_select_all;
				this.show_edit_due_date = false;
				this.bulk_selection = [];
				this.edit_due_date = null;
				this.edit_due_date_all = false;

				this.$snotify.info('Editing due date...');

				this.$store.dispatch('bulkDueDate', params).then((res) => {
					
					this.getProviders();
					
				}).catch((error) => {
					console.log(error);
				});


			},

			selectAll : function(){
				this.current_select_all = !this.current_select_all;
				for(var i in this.providers){
					if(this.providers[i].active)
						this.$set(this.providers[i], 'checked', this.current_select_all);
				}
			},
			singleApproval : function(provider){

				var params = {
					id : this.id,
					provider_id : provider.id
				}

				/*this.$store.dispatch('markCourseAsCompleted', params).then((res) => {
					console.log(res);
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				});*/
			},
			bulkApproval : function(){

				var params = {
					id : this.id,
					provider_ids : this.getProvidersForBulkApproval(),
					filters : {

					}
				}

				if(this.approve_all)
					params.filters.all = true;

				this.current_select_all = !this.current_select_all;
				this.approve_group = false;
				this.bulk_approval = [];
				this.approve_all = false;


				this.$snotify.info('Approving employees...');

				this.$store.dispatch('markCourseAsCompletedBulk', params).then((res) => {
					this.getProviders();
				}).catch((error) => {
					console.log(error);
					this.approve_all = false;
				});
			},
			
			getProviderName : function(provider_id){
				for(var i in this.providers){
					if(this.providers[i].id == provider_id)
						return this.providers[i].first_name + " " + this.providers[i].last_name;
				}
			},
			setFilterGraphics : function(selection){
				console.log("parent", selection);
				this.filter_graphics = selection;
				this.getProviders();
			},

			keyUpSearchByName : function(){
				clearTimeout(this.timeout_input_name);

				this.timeout_input_name = setTimeout( () => {
					this.getProviders();
				}, 500)
			},
			keyUpSearchByNameAllProviders : function(){
				clearTimeout(this.timeout_input_name);

				this.timeout_input_name = setTimeout( () => {
					this.getAllProviders();
				}, 500)
			},
			resetModal: function(){
				this.provider_data = {
					ssn : '',
					first_name : '',
					last_name : '',
					// dob: '',
					email : '',
					// gender: '',
					preferred_language: '',
					phone: '',
					uid : null
				}
				this.componentKey += 1
			},
			onSubmitNewProvider : function(new_provider_data){

				this.provider_data = new_provider_data
				console.log(new_provider_data)
				this.$store.dispatch('createProvider', this.provider_data).then((res) => {
					this.getProviders();
					this.getAllProviders();

					this.show_add_hha = false;

					this.provider_data = {
						ssn : '',
						first_name : '',
						last_name : '',
						// dob: '',
						email : '',
						// gender: '',
						preferred_language: '',
						phone: '',
						uid : null
					}
				}).catch((error) => {
					
				});
				
			},
			clearFilters : function(){
				this.filter_graphics = {
					type : 'none',
					row : -1,
					column : -1
				}

				this.filters.names = '';
				this.search = '';
				this.current_page = 1;

				this.getProviders();
			},
			toggleProvider : function(provider){
				if(provider.in_course){
					this.addProvider(provider.id);
				}else{
					this.provider_to_delete = provider;
					this.deleteProvider();
				}
			},
			changePerPage : function(value, id){

				this.current_page = Math.ceil(this.from/value);
				
				this.per_page = value;
				this.page_loading = false;
				this.getProviders();
			},
			changePerPageAllProviders : function(value, id){

				this.all_providers_table.current_page = Math.ceil(this.all_providers_table.from/value);

				this.all_providers_table.per_page = value;
				this.page_loading = false;
				this.getAllProviders();
			},

			getPreferredLanguages : function(){
				this.$store.dispatch('getPreferredLanguages', {}).then((res) => {
					this.preferred_languages = res.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			messageToAll : function(){
				//this.forceSelectAll();
				this.send_group_message = true;
				this.send_message_to_all = true;
			},
			
			forceSelectAll : function(){
				this.current_select_all = !this.current_select_all;
				for(var i in this.providers){
					if(this.providers[i].active)
						this.$set(this.providers[i], 'checked', true);
				}
			},

			approveAll : function(){
				this.approve_all = true;
				this.approve_group = true;
				this.forceSelectAllApprove();
			},
			
			forceSelectAllApprove : function(){
				this.current_select_all = !this.current_select_all;
				for(var i in this.providers){
					if(this.providers[i].active && this.providers[i].completion == 100)
						this.$set(this.providers[i], 'checked', true);
				}
			},

			sendCertificate : function(course_id, provider_id){
				var params = {
					id : course_id,
					provider_id : provider_id
				}
				this.$store.dispatch('sendCertificate', params).then((res) => {
					console.log(res);
				}).catch((error) => {
					console.log(error);
				});

				
			},

			downloadCert : function(url){
				window.open(url, '_self');
			},

			downloadBulkCerts : function(){

				var provider_ids = this.getProvidersForBulkCert().join(',');
				var download_token = this.$store.getters.getUser.download_token;

				var url = this.config.DOWNLOAD_BULK_CERTIFICATES.replace('%COURSE_ID%', this.id);

				url = url + '?provider_ids=' +provider_ids +'&download_token='+download_token;

				window.open(url, '_self');
			},

		
			downloadAllkCerts : function(){

				var params = {
					id : this.id
				}

				this.$store.dispatch('getCertificatesURL', params).then((res) => {
					console.log(res, this.config.DOWNLOAD_BULK_CERTIFICATES);

					var provider_ids = res.data.join(',');
					var download_token = this.$store.getters.getUser.download_token;

					var url = this.config.DOWNLOAD_BULK_CERTIFICATES.replace('%COURSE_ID%', this.id);

					url = url + '?provider_ids=' +provider_ids +'&download_token='+download_token;

					window.open(url, '_self');

				}).catch((error) => {
					console.log(error);
				});

				
			},

			setCanDownloadCertificate : function(){

				var params = {
					id : this.id,
					value : !this.course_data.can_download_certificate
				}

				this.$store.dispatch('setCanDownloadCertificate', params).then((res) => {
					console.log(res);

				//	this.getCourse();

				}).catch((error) => {
					console.log(error);
				});
			},

			getSubroles : function(){
				var params = {
					id : '_'
				}

				this.$store.dispatch('getOrganizationSubroles', params).then((res) => {
					
					for(var i in res.data.data){
						var obj = res.data.data[i];

						/**
						manager_approving_the_hha_score : '',
						coordinator : '',
						supporting_rn : '',
						lhcsa_manager
						*/
						switch(obj.type){
							case 'manager' :
								this.managers.push(obj); 

								if(obj.is_default){
									this.provider_data.lhcsa_manager = obj;
								}
								break;
							case 'supporting_rn' :
								this.supporting_rn.push(obj); 
								if(obj.is_default){
									this.provider_data.supporting_rn = obj;
								}
								break;
							case 'coordinator' :
								this.coordinators.push(obj); 

								if(obj.is_default){
									this.provider_data.coordinator = obj;
								}

								break;
							case 'approve_rn' : 
								this.approving_completions.push(obj); 
								
								if(obj.is_default){
									this.provider_data.manager_approving_the_hha_score = obj;
								}

								break;
						}
					}



				}).catch((error) => {
					console.log(error);
				});
			},
			getDisciplines : function(){
				var params = {
					id : '_',
					filters : {
						type : 'discipline'
					}
				}

				this.$store.dispatch('getTaxonomyValues', params).then((res) => {
					this.disciplines = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			getLocations : function(){
				var params = {
					id : '_',
					filters : {
						type : 'location'
					}
				}

				this.$store.dispatch('getTaxonomyValues', params).then((res) => {
					this.locations = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			getMyOrganization : function(){

				this.$store.dispatch('getMyOrganization', {}).then((res) => {
					this.location_mandatory = res.data.organization.location_mandatory;
					this.discipline_mandatory = res.data.organization.discipline_mandatory;
					this.show_organization_details = true;
				}).catch((error) => {
					console.log(error);
				});
			},

			newProviderAddToCourse : function(params){
				this.componentKey += 1;
				this.provider_data.phone = params.phone;
				this.provider_data.country_code = params.country_code;
				this.new_provider = true;
				this.show_add_hha = true;
			},
			//DEV METHODS
			resetStatus : function(){
				this.$store.dispatch('devResetOpcs', {}).then((res) => {
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				})
			},
			resetLessonProgress : function(){
				this.$store.dispatch('devResetOpcls', {}).then((res) => {
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				});
			},
			completeLessons : function(provider_id){
				var params = {
					filters : {
						course_id : this.id,
						provider_id : provider_id
					}
				}
				this.$store.dispatch('devCompleteAllLessons', params).then((res) => {
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				});
			},
			resetLessons : function(provider_id){
				var params = {
					filters : {
						course_id : this.id,
						provider_id : provider_id
					}
				}
				this.$store.dispatch('devResetAllLessons', params).then((res) => {
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				});
			},
			resetStatusProvider : function(provider_id){
				var params = {
					filters : {
						course_id : this.id,
						provider_id : provider_id
					}
				}
				this.$store.dispatch('devResetStatus', params).then((res) => {
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				});
			},
			setImg : function(file, dataUrl){
				this.provider_data.image = dataUrl;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/organizations/courses/OrganizationCourseDetailComponent.vue